var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "22px",
    viewBox: "0 0 18 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Task") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets_Export",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Task",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "task-24px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25,0 L2.25,0 C1.0125,0 0.01125,0.99 0.01125,2.2 L0,19.8 C0,21.01 1.00125,22 2.23875,22 L15.75,22 C16.9875,22 18,21.01 18,19.8 L18,6.6 L11.25,0 Z M7.8075,17.6 L3.825,13.706 L5.41125,12.155 L7.79625,14.487 L12.56625,9.823 L14.1525,11.374 L7.8075,17.6 Z M10.125,7.7 L10.125,1.65 L16.3125,7.7 L10.125,7.7 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.e71440e3b23e6e6f2f6fde1291de611a.svg";
export { ForwardRef as ReactComponent };